import { selectCredentials } from '@views/loginView/state/loginSlice'
import { all, call, takeEvery, put, select } from 'redux-saga/effects'
import {
  getPrepaymentsFailed,
  getPrepaymentsSuccess,
  PrepaymentResponse
} from '@views/prepayments/state/prepaymentsSlice'
import {
  CommissionSummaryResponse,
  CommissionDraftContext,
  getCommissionContextSuccess,
  getCommissions,
  getCommissionsFailed,
  getCommissionsSuccess,
  Invoice,
  postInvoiceSuccess,
  postInvoice
} from './commissionsSlice'
import { getCommissionContextService, getCommissionsService, postInvoiceService } from '@http/commissionsService'
import { getPrepaymentsService } from '@http/prepaymentsService'
import { PayloadAction } from '@reduxjs/toolkit'

const getErrorMessage = (error: any) =>
  error?.response?.data?.message || error?.message || 'Error procesando la cuenta de cobro'

export function* commissionsHttp() {
  const { cocap } = yield select(selectCredentials)
  try {
    const [commissions, context]: [CommissionSummaryResponse, CommissionDraftContext] = yield all([
      call(getCommissionsService, cocap),
      call(getCommissionContextService, cocap)
    ])
    yield put(getCommissionsSuccess(commissions))
    yield put(getCommissionContextSuccess(context))
  } catch (e) {
    yield put(getCommissionsFailed(getErrorMessage(e)))
  }
}

export function* postInvoiceSaga({ payload }: PayloadAction<Invoice>) {
  const { cocap, userId } = yield select(selectCredentials)
  try {
    yield call(postInvoiceService, cocap, { ...payload, userId })
    yield put(postInvoiceSuccess())

    if (payload.type === 'prepayment') {
      const prepayments: PrepaymentResponse = yield call(getPrepaymentsService, cocap)
      yield put(getPrepaymentsSuccess(prepayments))
      return
    }

    const [commissions, context]: [CommissionSummaryResponse, CommissionDraftContext] = yield all([
      call(getCommissionsService, cocap),
      call(getCommissionContextService, cocap)
    ])
    yield put(getCommissionsSuccess(commissions))
    yield put(getCommissionContextSuccess(context))
  } catch (e) {
    if (payload.type === 'prepayment') {
      yield put(getPrepaymentsFailed(getErrorMessage(e)))
      return
    }

    yield put(getCommissionsFailed(getErrorMessage(e)))
  }
}

export default function* commissionsSaga() {
  yield takeEvery(getCommissions.type, commissionsHttp)
  yield takeEvery(postInvoice.type, postInvoiceSaga)
}
